export type ITree<T> = Array<ITreeNode<T>>;

export type ITreeNode<T> = T & {
  depth: number;
  children?: ITree<T>;
};

export type IHierarchicItem = {
  _id: string;
  parentId?: string;
};

export const makeTree = <T extends IHierarchicItem>(
  items: Array<T>,
  maxDepth?: number,
  parentId?: string,
  depth = 0,
): Array<ITreeNode<T>> =>
  items
    .filter((item) =>
      parentId !== undefined ? item.parentId === parentId : !item.parentId,
    )
    .map((child) => ({
      ...child,
      children:
        maxDepth === undefined || depth < maxDepth - 1
          ? makeTree(items, maxDepth, child._id, depth + 1)
          : undefined,
      depth,
    }));

export const findPath = <T extends IHierarchicItem>(
  items: Array<T>,
  id: string,
): Array<T> => {
  const item = items.find((item) => item._id === id);
  if (!item) {
    return [];
  }

  const ancestors = [item];
  if (item.parentId) {
    ancestors.push(...findPath(items, item.parentId));
  }

  return ancestors;
};
